// Marketplace Phase 1 — UnknownTermsPanel (Feb 2026).
//
// Surfaces the top K-anonymous custom_*_other values that did NOT match
// the catalog (≥5 users typed the same thing). This is the input
// Roberto reads when deciding whether to expand the seed catalogs.
//
// No user IDs. Each row is a free-text value with its occurrence count.

import React from "react";
import { Lightbulb } from "lucide-react";

const FIELD_BADGE = {
  brands: { color: "bg-emerald-100 text-emerald-800", label: "marketplace.demand.fieldBrands" },
  product_categories: { color: "bg-sky-100 text-sky-800", label: "marketplace.demand.fieldProductCats" },
  sponsorship_categories: { color: "bg-amber-100 text-amber-800", label: "marketplace.demand.fieldSponsorCats" },
};

export const UnknownTermsPanel = ({ items, t }) => {
  return (
    <div
      className="rounded-xl border border-slate-200 bg-white overflow-hidden"
      data-testid="demand-unknown-panel"
    >
      <div className="px-4 py-3 border-b border-slate-100 bg-slate-50 flex items-center gap-2">
        <Lightbulb className="h-4 w-4 text-amber-600" />
        <h3 className="text-sm font-semibold text-slate-700">
          {t("marketplace.demand.unknownTitle")}
        </h3>
      </div>
      <div className="px-4 py-2 text-xs text-slate-500 bg-slate-50/40 border-b border-slate-100">
        {t("marketplace.demand.unknownSubtitle")}
      </div>
      {(!items || items.length === 0) ? (
        <div className="p-6 text-center text-sm text-slate-400" data-testid="demand-unknown-empty">
          {t("marketplace.demand.unknownEmpty")}
        </div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {items.map((it, idx) => {
            const badge = FIELD_BADGE[it.field] || FIELD_BADGE.brands;
            return (
              <li
                key={`${it.field}-${it.text}-${idx}`}
                className="px-4 py-2 flex items-center justify-between gap-3"
                data-testid={`demand-unknown-row-${idx}`}
              >
                <div className="flex items-center gap-2 min-w-0">
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium shrink-0 ${badge.color}`}>
                    {t(badge.label)}
                  </span>
                  <span className="text-sm text-slate-700 truncate" title={it.text}>
                    {it.text}
                  </span>
                </div>
                <span className="font-mono text-xs text-slate-900 font-semibold">{it.count}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default UnknownTermsPanel;
